import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import BootstrapVue from 'bootstrap-vue'
import VueScrollTo from 'vue-scrollto'
import Carousel3d from 'vue-carousel-3d'
import Multiselect from 'vue-multiselect'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faCheck,
    faEnvelope,
    faLock,
    faChevronLeft,
    faChevronRight,
    faSpinner,
    faUser,
    faSearch,
    faFilter,
    faChevronDown,
    faPlus,
    faChevronUp,
    faCheckCircle,
    faTimesCircle,
    faCheckSquare,
    faSquare,
    faTrash,
    faTrashAlt,
    faMinus,
    faPen,
    faSortDown,
    faSortUp,
    faFile,
    faDownload,
    faSave,
    faTimes,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faUpload,
    faSignOutAlt
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import Datepicker from 'vuejs-datepicker'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './ml'

import myFooter from './components/footer/myFooter'
import Plan from './components/plans/Plan'
import TrackBrandsIcon from './components/icons/TrackBrandsIcon'
import ReportsIcon from './components/icons/ReportsIcon'
import SearchInDatabaseIcon from './components/icons/SearchInDatabaseIcon'
import UploadTrademarkIcon from './components/icons/UploadTrademarkIcon'
import UserListIcon from './components/icons/UserListIcon'
import DepartmentIcon from './components/icons/DepartmentIcon'
import GoodServiceIcon from './components/icons/GoodServiceIcon'
import KindIcon from './components/icons/KindIcon'
import TradeMarkIcon from './components/icons/TradeMarkIcon'
import NumberOfRequestIcon from './components/icons/NumberOfRequestIcon'
import OwnerIcon from './components/icons/OwnerIcon'
import OwnerAddressIcon from './components/icons/OwnerAddressIcon'
import RegistrationDateIcon from './components/icons/RegistrationDateIcon'
import RegistrationNumberIcon from './components/icons/RegistrationNumberIcon'
import StatusIcon from './components/icons/StatusIcon'
import ProtectionIcon from './components/icons/ProtectionIcon'
import ArchiveIcon from './components/icons/ArchiveIcon'
import ImageIcon from './components/icons/ImageIcon'
import TextIcon from './components/icons/TextIcon'
import AudioIcon from './components/icons/AudioIcon'
import ThreeDimIcon from './components/icons/3DIcon'
import FilterEmptyIcon from './components/icons/FilterEmptyIcon'
import FilterFullIcon from './components/icons/FilterFullIcon'
import TrackedByIcon from './components/icons/TrackedByIcon'
import ColorsIcon from './components/icons/ColorsIcon'
import NotesIcon from './components/icons/NotesIcon'
import OwnersListIcon from './components/icons/OwnersListIcon'
import NiceClassesIcon from './components/icons/NiceClassesIcon'
import ViennaClassesIcon from './components/icons/ViennaClassesIcon'

import {countries} from './helpers/countries'

Vue.config.productionTip = false;

library.add(
    faCheck,
    faEnvelope,
    faLock,
    faChevronLeft,
    faSpinner,
    faUser,
    faSearch,
    faFilter,
    faChevronDown,
    faChevronRight,
    faPlus,
    faChevronUp,
    faCheckCircle,
    faTimesCircle,
    faCheckSquare,
    faSquare,
    faTrash,
    faMinus,
    faTrashAlt,
    faPen,
    faSortDown,
    faSortUp,
    faFile,
    faDownload,
    faSave,
    faTimes,
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faUpload,
    faSignOutAlt);
Vue.component('myFooter', myFooter);
Vue.component('Plan', Plan);
Vue.component('TrackBrandsIcon', TrackBrandsIcon);
Vue.component('ReportsIcon', ReportsIcon);
Vue.component('SearchInDatabaseIcon', SearchInDatabaseIcon);
Vue.component('UploadTrademarkIcon', UploadTrademarkIcon);
Vue.component('UserListIcon', UserListIcon);
Vue.component('DepartmentIcon', DepartmentIcon);
Vue.component('GoodServiceIcon', GoodServiceIcon);
Vue.component('KindIcon', KindIcon);
Vue.component('TradeMarkIcon', TradeMarkIcon);
Vue.component('NumberOfRequestIcon', NumberOfRequestIcon);
Vue.component('OwnerIcon', OwnerIcon);
Vue.component('OwnerAddressIcon', OwnerAddressIcon);
Vue.component('RegistrationDateIcon', RegistrationDateIcon);
Vue.component('RegistrationNumberIcon', RegistrationNumberIcon);
Vue.component('StatusIcon', StatusIcon);
Vue.component('ProtectionIcon', ProtectionIcon);
Vue.component('ArchiveIcon', ArchiveIcon);
Vue.component('ImageIcon', ImageIcon);
Vue.component('TextIcon', TextIcon);
Vue.component('AudioIcon', AudioIcon);
Vue.component('ThreeDimIcon', ThreeDimIcon);
Vue.component('FilterEmptyIcon', FilterEmptyIcon);
Vue.component('FilterFullIcon', FilterFullIcon);
Vue.component('TrackedByIcon', TrackedByIcon);
Vue.component('ColorsIcon', ColorsIcon);
Vue.component('NotesIcon', NotesIcon);
Vue.component('OwnersListIcon', OwnersListIcon);
Vue.component('NiceClassesIcon', NiceClassesIcon);
Vue.component('ViennaClassesIcon', ViennaClassesIcon);
Vue.component('multiselect', Multiselect);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vuejs-datepicker', Datepicker);

Vue.use(VeeValidate);
Vue.use(VueScrollTo);
Vue.use(VueAxios, axios);
Vue.use(VeeValidate);
Vue.use(BootstrapVue);
Vue.use(Carousel3d);

Vue.prototype.$countries = countries;

Vue.filter('priceNote', function (price) {
    let stringPrice = price.toString().split('.');
    return stringPrice[0];
});

Vue.filter('priceCent', function (price) {
    let stringPrice = price.toString().split('.');
    return stringPrice[1];
});

Vue.filter('dateFormat', function (value) {
    if (!value) {
        return '';
    }
    let validDateObject = new Date(value);
    let month = ('0' + (validDateObject.getMonth() + 1)).slice(-2);
    let day = ('0' + validDateObject.getDate()).slice(-2);
    return `${validDateObject.getFullYear()}-${month}-${day}`;
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
